import { PATH } from '@/router/PATH';

/** Tab identity — also the `Tabs` selection key and the testid discriminator. */
export type StatementsTabId = 'balance-sheet' | 'profit-loss';

export type StatementsTab = {
    id: StatementsTabId;
    /** Absolute route this tab owns; selecting the tab navigates here. */
    path: string;
    labelKey: string;
};

/**
 * The statement tabs, in display order. Balance Sheet leads — it is the
 * statement people open first, and it is the one the shell's range is read
 * as-of rather than across.
 */
export const STATEMENTS_TABS: StatementsTab[] = [
    {
        id: 'balance-sheet',
        path: PATH.ACCOUNTING.STATEMENTS.BALANCE_SHEET,
        labelKey: 'accounting.statements.tabs.balanceSheet',
    },
    {
        id: 'profit-loss',
        path: PATH.ACCOUNTING.STATEMENTS.PROFIT_LOSS,
        labelKey: 'accounting.statements.tabs.profitLoss',
    },
];

export const DEFAULT_STATEMENTS_TAB_ID: StatementsTabId = 'balance-sheet';

/**
 * Which tab the current URL selects. The bare shell path and anything
 * unrecognised fall back to the default tab, so the bar is never rendered with
 * nothing selected.
 */
export const resolveStatementsTabId = (pathname: string): StatementsTabId => {
    const matched = STATEMENTS_TABS.find(
        (tab) => pathname === tab.path || pathname.startsWith(`${tab.path}/`),
    );

    return matched?.id ?? DEFAULT_STATEMENTS_TAB_ID;
};

/** Route target for a tab id; unknown ids land on the default tab's route. */
export const resolveStatementsTabPath = (id: string): string => {
    const matched = STATEMENTS_TABS.find((tab) => tab.id === id);

    return matched?.path ?? PATH.ACCOUNTING.STATEMENTS.BALANCE_SHEET;
};
